"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatSource = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common");
require("@/components/overlay/popover/popover");
const utils_1 = require("@/utils");
/**
 * AI 응답 출처 소스 칩. 클릭하면 칩에 앵커된 popover로 상세 정보를 펼칩니다.
 * 열기·닫기·aria-expanded는 mm-popover가 소유하며, 여러 칩은 mm-button-group으로 묶습니다.
 */
let ChatSource = class ChatSource extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.href = '';
        this.heading = '';
        this.description = '';
        this.label = '';
        // popover는 portal로 옮겨져 한 트리에 모이므로, 칩이 여럿이어도 id가 겹치지 않게 한다.
        this.detailId = (0, utils_1.uniqueId)('source-detail');
    }
    render() {
        return (0, lit_1.html) `
      <mm-button variant="tertiary" aria-controls=${this.detailId}>
        ${this.renderIcon()} ${this.domain}
      </mm-button>
      <mm-popover id=${this.detailId}>
        <mm-flex direction="column" gap="1">
          ${this.renderDetailHeader()} ${this.renderHeading()} ${this.renderDescription()}
          ${this.renderLink()}
        </mm-flex>
      </mm-popover>
    `;
    }
    renderIcon() {
        if (!this.icon)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-icon name=${this.icon}></mm-icon>
    `;
    }
    renderDetailHeader() {
        if (!this.href)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-flex align-items="center" gap="1">
        ${this.renderIcon()}
        <mm-text size="12" max-lines="1" color="light">${this.domain}</mm-text>
      </mm-flex>
    `;
    }
    renderHeading() {
        if (!this.heading)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-paragraph max-lines="3">${this.heading}</mm-paragraph>
    `;
    }
    renderDescription() {
        if (!this.description)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-paragraph size="small" max-lines="3">${this.description}</mm-paragraph>
    `;
    }
    renderLink() {
        if (!this.href)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-link href=${this.href} external>방문하기</mm-link>
    `;
    }
    get domain() {
        if (this.label)
            return this.label;
        try {
            return new URL(this.href).hostname.replace(/^www\./, '');
        }
        catch {
            return this.href;
        }
    }
};
ChatSource.styles = (0, lit_1.css) `
    :host {
      display: inline-block;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ChatSource.prototype, "href", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ChatSource.prototype, "heading", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ChatSource.prototype, "description", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ChatSource.prototype, "label", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ChatSource.prototype, "icon", void 0);
ChatSource = __decorate([
    (0, decorators_js_1.customElement)('mm-chat-source')
], ChatSource);
exports.ChatSource = ChatSource;
//# sourceMappingURL=data:application/json;base64,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